import { LAYOUT } from "@/router/constant";
import { AppRouteModule } from "@/router/types";
import { t } from '@/hooks/web/useI18n';

const game: AppRouteModule = {
    path: '/game',
    name: 'Game',
    component: LAYOUT,
    meta: {
        title: t('routes.index.game.game'),
    },
    children: [
        {
            path: 'robot',
            name: 'GameRobot',
            component: () => import('@/views/main/game/robot.vue'),
            meta: {
                title: t('routes.index.game.robot'),
            },
        },
        {
            path: 'compete',
            name: 'GameCompete',
            component: () => import('@/views/main/game/compete.vue'),
            meta: {
                title: t('routes.index.game.compete'),
            },
        },
    ],
}

export default game;